import { useMutation } from '@apollo/client';
import { message, Tabs } from 'antd';
import React, { useState } from 'react'
import { gqlSchema } from '../../../../gql/schema';
import Button from '../../../../shared/Button'
import { TabPane } from '../../InvestigationCard/styles';


const AddBookCodes = ({ shopifyProductId, refetchCodes, codeData, loading }: any) => {
  const [numberInput, setNumberInput] = useState<number | undefined>();
  const [codes, setCodes] = useState<string[]>([]);
  const [textareaValue, setTextareaValue] = useState('');
  const [loader, setLoader] = useState(false);



  const [assignCodeToBooksRandom] = useMutation(gqlSchema.BookSchema.mutations.GenerateAndSaveCodes, {
    onCompleted: async () => {
      message.success('Random codes created successfully');
      setNumberInput(undefined);
      await refetchCodes();
    },
    onError: (error) => {
      message.error(`Error in generating random codes - ${error.message || 'Unexpected Error'}`);
    }
  });

  const [assignCodeToBooks] = useMutation(gqlSchema.BookSchema.mutations.AssignCodeToBooks, {
    onCompleted: async () => {
      message.success('Codes assigned successfully');
      setCodes([]);
      await refetchCodes();
    },
    onError: (error) => {
      message.error(`Error in assigning codes - ${error.message || 'Unexpected Error'}`);
    }
  });

  const [generateCodeToBooks] = useMutation(gqlSchema.BookSchema.mutations.GenerateAndSendEmail, {
    onCompleted: async () => {
      message.success('Codes assigned successfully');
      setCodes([]);
      await refetchCodes();
    },
    onError: (error) => {
      message.error(`Error in assigning codes - ${error.message || 'Unexpected Error'}`);
    }
  });

  const handleChange = (value: string) => {
    const newCodes = value.split(/[\n,]+/).filter(code => code.trim() !== '');
    setCodes(newCodes);
  };

  const handleNumberChange = (value: string) => {
    const num = value === '' ? undefined : parseInt(value, 10);
    setNumberInput(num);
  };

  const handleSubmit = async () => {
    setLoader(true);
    try {
      if (codes.length > 0) {
        await assignCodeToBooks({
          variables: {
            codes,
            shopifyProductId,
          },
        });
      } else if (numberInput && numberInput > 0) {
        await assignCodeToBooksRandom({
          variables: {
            numberOfCodes: numberInput,
            bookId: shopifyProductId,
          },
        });
      } else {
        message.error('Please enter codes manually or specify a valid number to generate.');
      }
    } finally {
      setLoader(false);
    }
  }

  const handleChangeEmail = (value: string) => {
    setTextareaValue(value);
  };

  const handleNumberChangeEmail = (value: string) => {
    const number = parseInt(value, 10);
    setNumberInput(isNaN(number) ? undefined : number);
  };


const handleSubmitEmail = async () => {
  if (!textareaValue?.trim()) {
    message.error('Please enter at least one email address');
    return;
  }

  const cleanedEmails = textareaValue
    .split(/[\n,]+/)
    .map(email => email.trim())
    .filter(email => !!email);

  if (!cleanedEmails.length) {
    message.error('No valid email addresses provided');
    return;
  }

  setLoader(true);
  try {
    if (numberInput && Number(numberInput) > 0) {
      // Case 1: Organization (isOrg: true)
      await generateCodeToBooks({
        variables: {
          emails: cleanedEmails,
          bookId: shopifyProductId,
          numberOfCodes: Number(numberInput),
          isOrg: true,
        },
      });
    } else {
      // Case 2: Individual (isOrg: false)
      await generateCodeToBooks({
        variables: {
          emails: cleanedEmails,
          bookId: shopifyProductId,
          numberOfCodes: numberInput || 1,
          isOrg: false,
        },
      });
    }
  } finally {
    setLoader(false);
  }
};



  return (
    <Tabs defaultActiveKey="1" centered tabBarGutter={50}>
      <TabPane tab="Book Codes" key="1">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            alignItems: 'center',
            paddingTop: '20px',
          }}
        >
          <textarea
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Enter your codes (comma or newline separated)"
            style={{
              width: '100%',
              height: '200px',
              border: '1px solid #ccc',
              padding: '8px',
              fontSize: '1rem',
              borderRadius: '4px',
            }}
          />
          <input
            type="number"
            placeholder="Enter number of random codes"
            value={numberInput ?? ''}
            onChange={(e) => handleNumberChange(e.target.value)}
            style={{
              width: '100%',
              height: '40px',
              border: '1px solid #ccc',
              padding: '8px',
              fontSize: '1rem',
              borderRadius: '4px',
            }}
          />
          <Button
            text={`Add Codes ${codes?.length ? ` :- ${codes.length}` : ''}`}
            disabled={!(!!codes?.length !== !!numberInput)}
            loading={loader}
            style={{ backgroundColor: '#4367E9', color: '#fff', width: "300px" }}
            onClick={() => handleSubmit()}
            block
          />
        </div>
      </TabPane>
      <TabPane tab="Send Emails" key="2">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            alignItems: 'center',
            paddingTop: '20px',
          }}
        >
          <textarea
            onChange={(e) => handleChangeEmail(e.target.value)}
            placeholder="Enter your email addresses (comma or newline separated)"
            style={{
              width: '100%',
              height: '200px',
              border: '1px solid #ccc',
              padding: '8px',
              fontSize: '1rem',
              borderRadius: '4px',
            }}
          />
          <input
            type="number"
            placeholder="Enter number of random codes"
            value={numberInput ?? ''}
            onChange={(e) => handleNumberChangeEmail(e.target.value)}
            style={{
              width: '100%',
              height: '40px',
              border: '1px solid #ccc',
              padding: '8px',
              fontSize: '1rem',
              borderRadius: '4px',
            }}
          />
          <Button
            text={`Add Codes ${codes?.length ? ` :- ${codes.length}` : ''}`}
            disabled={!textareaValue}
            loading={loader}
            style={{ backgroundColor: '#4367E9', color: '#fff', width: "300px" }}
            onClick={() => handleSubmitEmail()}
            block
          />
        </div>
      </TabPane>
    </Tabs>
  );
};




export default AddBookCodes
